<template>
  <canvas
    ref="graph"
    height="300px"
    width="1000px"
  >
  </canvas>
</template>

<script>
/* eslint-disable */
import Chart from 'chart.js';

export default {
  props: {
    graphData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartUI: null,
    };
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
  },
  methods: {
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: []
        },
        options: {
          responsive: true,
          // maintainAspectRatio: false,
          scales: {
            xAxes: [{
              type: 'time',
              display: true,
              distribution: 'series',
              gridLines: {
                display: false,
                color: 'rgba(150, 150, 150, 0.5)'
              },
              ticks: {
                source: 'auto',
              },
              time: {
                displayFormats: {
                  second: 'h:mm:ss',
                  minute: 'HH:mm:ss',
                },
                round: 'second',
                unit: 'minute',
              }
            }],
            yAxes: [{
              display: true,
              padding: 0,
              beginAtZero: true,
              gridLines: {
                display: false,
                color: 'rgba(150, 150, 150, 0.5)'
              },
            }]
          }
        }
      };
      // Map different device ID events to separate arrays
      var result = this.graphData.map((el) => ({ x: new Date(el.timestamp), y: el.fps }));
        // Add data to chart config
        config.data.datasets.push(
          {
            label: 'fps',
            borderColor: 'green',
            backgroundColor: 'green',
            fill: false,
            steppedLine: true,
            data: result,
          }
        );

      const chart = this.$refs.graph;
      this.chartUI = new Chart(chart, config);
    },
  },
};
</script>
<style scoped>
</style>
